




































import {
  defineComponent, watchEffect, reactive, watch, ref,
} from '@vue/composition-api';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';
import { useSelectable, useRouter } from '@ideavivat/vivat-2';

import getRole from '@/gql/usersSetting/getRole.gql';
import getPermissions from '@/gql/usersSetting/getPermissions.gql';
import updateRole from '@/gql/usersSetting/updateRole.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import useAuth from '@/useAuth';

const CommonFormWithRoleEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    roleId: {
      type: String,
    },
    module: {
      type: Array,
      default: () => ([]),
    },
  },
  setup(props) {
    const { hasPermission } = useAuth();
    const { router } = useRouter();

    const { result } = useQuery(getPermissions);
    const permissions = useResult(result, [], (data: any) => {
      const perms = data.permissions;
      const permsByModule = props.module.map((module: any) => ({ module, permissions: [] })) as {
        module: string;
        permissions: {
          id: number;
          module: string;
          moduleDisplayName: string;
          name: string;
          displayName: string;
        }[];
      }[];
      perms.forEach((perm: any) => {
        if (perm.displayName === '') return; // in case of hidden perm: like wildcard
        const permByModuleEntries = permsByModule.filter((pbm: any) => pbm.module === perm.module);
        if (permByModuleEntries.length === 0) {
          permsByModule.push({
            module: perm.module,
            permissions: [],
          });
        }
        const permIndex = permsByModule.findIndex((pbm: any) => pbm.module === perm.module);
        permsByModule[permIndex].permissions.push(perm as any);
      });
      return permsByModule;
    });

    const form = reactive({
      name: '',
      permissions: [],
    });

    const { result: getRoleQuery } = useQuery(getRole, () => ({ id: props.roleId }));
    const roleResult = useResult(getRoleQuery, [], (data) => data.role);
    watch(roleResult, (newValue: any) => {
      if (!newValue) {
        router.push({ name: 'User' });
        return;
      }
      form.name = newValue.name;
      form.permissions = (newValue.permissions || []).map((elm: any) => elm.id);
    });

    const {
      selectedItems: selectedList,
      onSelect: onSelectList,
      isSelected: isSelectedList,
    } = useSelectable(form.permissions, (elm: any) => elm.id);
    watchEffect(() => {
      selectedList.value = form.permissions;
    });

    function onSelect(items: any, setTo: any) {
      onSelectList(items, setTo);
      form.permissions = selectedList.value;
    }

    const updateRoleMutation = useMutation(updateRole, () => ({
      variables: {
        id: props.roleId,
        ...form,
      },
      refetchQueries: ['getRoles', 'getRole', 'getMyInfo'],
    }));
    const { refresh } = useAuth();
    const doneModal = ref(null);
    updateRoleMutation.onDone(() => {
      refresh();
      (doneModal.value as any).compose({
        entity: 'กลุ่ม',
        action: 'แก้ไข',
      });
    });

    return {
      hasPermission,
      doneModal,
      updateRoleMutation,
      form,
      selectedList,
      onSelect,
      isSelectedList,
      permissions,
    };
  },
});

export default CommonFormWithRoleEditor;
